import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import webConfig from 'middlewares/WebConfig';

class CustomerHeader extends Component {
  constructor(props) {
    super(props);

    // UI Events
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onEmailCopyClicked = this.onEmailCopyClicked.bind(this);
    this.onPrintClicked = this.onPrintClicked.bind(this);
    this.onDisputeClicked = this.onDisputeClicked.bind(this);
    this.onReorderClicked = this.onReorderClicked.bind(this);
    this.onMarkReviewedClicked = this.onMarkReviewedClicked.bind(this);
  }

  onBackClicked() {
    alert("back");
  }

  onEmailCopyClicked() {
    const { controlNumber } = this.props.caseInfo;
    const { token, firstName, lastName, caseInfo } = this.props;

    const customerNumber = caseInfo.customerNumber;
    const policyNumber = caseInfo.policyNumber;
    const insuredFirst = caseInfo.insuredFirstName;
    const insuredLast = caseInfo.insuredLastName;

    const alias = `${firstName} ${lastName}`.trim();
    const subject = `Emailing Policy - ${policyNumber} ${insuredFirst} ${insuredLast}`.trim();

    const url = `${webConfig.orthosRoot}/sendemail.asp?ControlIDNumber=${controlNumber}&cAttachments=${controlNumber}-Report.pdf&cType=HomeOwnerPictures&cFromEmail=donotreply@mueller-inc.com&cAlias=${encodeURIComponent(alias)}&nCustomer=${customerNumber}&cPolicyNumber=${encodeURIComponent(policyNumber)}&cSubject=${encodeURIComponent(subject)}&SSO=${token}`;
    window.open(url, "_blank", "height=600,width=500,resiable=yes");
  }

  onPrintClicked() {
    const { controlNumber } = this.props.caseInfo;
    const { token, caseInfo } = this.props;

    const customerNumber = caseInfo.customerNumber;

    const url = `${webConfig.orthosRoot}/HomeOwnerPictures/${customerNumber}/${controlNumber}-Report.pdf?&SSO=${token}`;
    window.open(url, "_blank");
  }

  onDisputeClicked() {
    const { controlNumber } = this.props.caseInfo;
    const { token, email, caseInfo } = this.props;

    const policyNumber =  caseInfo.policyNumber;

    const url = `${webConfig.orthosRoot}/CustomerServiceIncident.aspx?ControlIDNumber=${controlNumber}&FromEmail=${encodeURIComponent(email)}&cToEmail=customerservice@mueller-inc.com&DatabaseType=H&PolicyNumber=${encodeURIComponent(policyNumber)}&SSO=${token}`;
    window.open(url, "_blank", "height=600,width=500,resiable=yes");
  }

  onReorderClicked() {
    const { controlNumber } = this.props.caseInfo;
    const { token } = this.props;

    const url = `${webConfig.orthosRoot}/reordercase.asp?ControlIDNumber=${controlNumber}&SSO=${token}`;
    window.open(url, "_blank", "height=600,width=500,resiable=yes");
  }

  onMarkReviewedClicked() {
    alert("reviewed");
  }

  render(){
    const { caseInfo } = this.props;

    return (
    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', pl: '40px' }}>
      {caseInfo && (
        <>
          <Button onClick={this.onBackClicked}>Back</Button>
          <Button onClick={this.onEmailCopyClicked}>Email Copy</Button>
          <Button onClick={this.onPrintClicked}>Print / Download</Button>
          <Button onClick={this.onDisputeClicked}>Send Dispute / Request Status</Button>
          <Button onClick={this.onReorderClicked}>Re-Order Case</Button>
          <Button onClick={this.onMarkReviewedClicked}>Mark Reviewed</Button>      
        </>
      )}
    </Box>
    );
  }
}

CustomerHeader.propTypes = {
  // redux props
  token: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  caseInfo: PropTypes.object,  
};

const mapStateToProps = (state) => {
  return {
    token: state.user.profile.token,
    firstName: state.user.profile.firstName,
    lastName: state.user.profile.lastName,
    email: state.user.profile.email,
    caseInfo: state.homeownerCustomer.caseInfo,
  };
};

export default connect(mapStateToProps)(CustomerHeader);